module.exports = __webpack_public_path__ + "img/smoker.b13a8b70.svg";